export class ActivityInstitutionInfo {
    constructor(
        public physicianName: string = '',
        public institutionName: string = '',
        public city: string = '',
        public state: string = '',
        public guid: string = '',
        public country: string = ''
    ) {}
}
